import z from "zod/v4";

import { AiNodeContextSchema } from "./context-schemas";
import { UserInputSchema } from "./node-execution";

export const NodeExecutionRequestSchema = z.object({
  nodeId: z.string(),
  context: AiNodeContextSchema,
  userInput: UserInputSchema.array().optional(),
});

export type NodeExecutionRequest = z.infer<typeof NodeExecutionRequestSchema>;
